import axios from "axios";
import { apiUrl, getAuthHeader } from "./base";

export type TTncStatus = 0 | 1 | 2; // 0 default, 1 accepted, 2 rejected

type TGetStatusResp = { status: boolean; message: string; data?: { status: TTncStatus, content: string, title: string } };

export async function getUserTncStatus(userId: string): Promise<TGetStatusResp> {
  try {
    const res = await axios.get(
      apiUrl(`api/aria/user/status/${userId}`, "aria"),
      await getAuthHeader("aria")
    );
    const data = res?.data ?? {};
    const normalized = "tnc_status" in data ? data : data?.data || {};
    return {
      status: true, message: "OK", data: {
        status: (normalized.tnc_status ?? 0) as TTncStatus,
        content: normalized.tnc_content,
        title: normalized.tnc_title || "Terms and Conditions"
      }
    };
  } catch (err: any) {
    return { status: false, message: err?.response?.data?.message || err.message };
  }
}

export async function updateUserTncStatus(userId: string, statusValue: TTncStatus) {
  try {
    await axios.put(
      apiUrl(`api/aria/user/status/${userId}`, "aria"),
      { status: statusValue },
      await getAuthHeader("aria")
    );
    return { status: true, message: "OK" };
  } catch (err: any) {
    return { status: false, message: err?.response?.data?.message || err.message };
  }
}
